module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bc-ticketing"
  }, [_c('div', {
    staticClass: "bc-ticketing__inner"
  }, [_c('h1', {
    staticClass: "bc-ticketing__title"
  }, [_vm._v(_vm._s(_vm.$T('官网票务页标题')))]), _vm._v(" "), _c('p', {
    staticClass: "bc-ticketing__desc"
  }, [_vm._v(_vm._s(_vm.$T('官网票务页说明')))]), _vm._v(" "), _c('div', {
    staticClass: "bc-ticketing__qr-wrap"
  }, [_c('img', {
    staticClass: "bc-ticketing__qr",
    attrs: {
      "src": _vm.qrSrc,
      "alt": _vm.$T('官网票务扫码购票')
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bc-ticketing__hint"
  }, [_vm._v(_vm._s(_vm.$T('官网票务扫码购票')))]), _vm._v(" "), _c('a', {
    staticClass: "bc-ticketing__btn",
    attrs: {
      "href": _vm.damaiUrl,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$T('官网票务前往大麦')) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da8e44e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/Ticketing.vue
// module id = 1600
// module chunks = 0